import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /jobs/$jobId → redirect to /app/jobs. The previous component
// (job detail page) is no longer reachable from in-app navigation — all
// in-app links go through /admin/jobs/$jobId (staff) or open the inline
// drawer under /app/jobs. The root gate handles the staff-vs-client_user
// redirect from /app/jobs to /admin/jobs automatically. Bookmarks lose the
// `$jobId` param, which is acceptable: the user can find the job in the
// list.
export const Route = createFileRoute("/jobs/$jobId")({
  beforeLoad: legacyRedirectTo("/app/jobs"),
  component: () => null,
});
